import { useQuery } from '@tanstack/react-query';
import * as sharedApi from 'shared/services/api';
import { METADATA_VALUES } from '@elementary/common-ui/constants/queryKeys';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';

const useResourcesMetadataOptions = () => {
  const selectedEnvId = useSelectedEnv();

  const { data: metadataData } = useQuery(
    [METADATA_VALUES, selectedEnvId],
    () => sharedApi.fetchMetadata(selectedEnvId!),
  );

  return {
    owners: [...(metadataData?.owners || []), 'No owners'],
    subscribers: [...(metadataData?.subscribers || []), 'No subscribers'],
    tags: [...(metadataData?.tags || []), 'No tags'],
    isCritical: [true, false],
    names: [...(metadataData?.asset_names || []), 'No name'],
    databases: [...(metadataData?.database_names || []), 'No database'],
    schemas: [...(metadataData?.schema_names || []), 'No schema'],
    testTags: [...(metadataData?.test_tags || []), 'No tags'],
    testOwners: [...(metadataData?.test_owners || []), 'No owners'],
  };
};

export default useResourcesMetadataOptions;
